import type { ModuleId, StaffRole } from '../../../../packages/contracts/src/index.js';

export type { ModuleId, StaffRole };

export const appModules: Array<{ readonly id: ModuleId; readonly label: string; readonly defaultRoles: readonly StaffRole[] }> = [
  { id: 'dashboard', label: 'Dashboard', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'calendar', label: 'Calendario', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'grooming', label: 'Grooming / estetica', defaultRoles: ['Administrator', 'Receptionist', 'Staff'] },
  { id: 'client-dogs', label: 'Clientes + perros', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'stays', label: 'Hotel', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'daycares', label: 'Guarderia', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'memberships', label: 'Membresias', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'services', label: 'Servicios', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'prices', label: 'Precios', defaultRoles: ['Administrator'] },
  { id: 'payments', label: 'Pagos', defaultRoles: ['Administrator', 'Receptionist'] },
  { id: 'users', label: 'Usuarios y permisos', defaultRoles: ['Administrator'] },
];

export type ModulePermissionMap = Record<ModuleId, StaffRole[]>;

export function defaultModulePermissions(): ModulePermissionMap {
  return Object.fromEntries(appModules.map((module) => [module.id, [...module.defaultRoles]])) as ModulePermissionMap;
}

export function normalizeModulePermissions(permissions?: Partial<Record<ModuleId, StaffRole[]>>): ModulePermissionMap {
  const defaults = defaultModulePermissions();
  return Object.fromEntries(appModules.map((module) => [module.id, permissions?.[module.id] ?? defaults[module.id]])) as ModulePermissionMap;
}

export function canAccessModule(roles: readonly StaffRole[], moduleId: ModuleId, permissions = defaultModulePermissions()) {
  if (roles.includes('Administrator')) return true;
  return roles.some((role) => permissions[moduleId]?.includes(role));
}
